module.exports = __webpack_public_path__ + "img/Academico_Build.121c4b7b.png";